import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=73f0dd14"
import script from "./SortableList.vue?vue&type=script&lang=js"
export * from "./SortableList.vue?vue&type=script&lang=js"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=73f0dd14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports